export const ASTUR_X_TOKEN = '1a116e02-47ae-4753-965a-af432f6e0edf';

export interface BuildAsturHeadersArgs {
  subscriptionId?: number | string | null;
}

/**
 * Shared headers required by channel API endpoints (generic/integration legacy endpoints).
 *
 * When using channelApi (axios): pass only subscriptionId; Authorization and X-Astur-Organization
 * are added by channelApi / NewApiComponent.
 *
 * Raw channel requests use sessionFetch with an explicit request scope; this
 * helper never resolves or emits organization identity.
 */
export function buildAsturHeaders(args?: BuildAsturHeadersArgs): Record<string, string> {
  const headers: Record<string, string> = {
    'x-astur-token': ASTUR_X_TOKEN,
  };

  const subscriptionId = args?.subscriptionId;
  if (subscriptionId !== null && subscriptionId !== undefined && String(subscriptionId).trim()) {
    headers['x-astur-subscription-id'] = String(subscriptionId);
  }

  return headers;
}
